'use client';
import Image from 'next/image';
import Link from 'next/link';


const Footer = () => {
  const socialLinks = [
    {
      src: "/images/facebook-logo.svg",
      alt: "facebook-logo",
      href: "https://www.facebook.com/AICapitalConnect/",
    },
    {
      src: "/images/x-twitter.svg",
      alt: "x-twitter",
      href: "https://twitter.com/AICapitalCon",
    },
    // {
    //   src: "/images/instagram-logo.svg",
    //   alt: "instagram",
    //   href: "https://www.instagram.com/aicapitalconnect/",
    // },
    {
      src: "/images/linkedIn.svg",
      alt: "LinkedIn",
      href: "https://www.linkedin.com/company/aicapitalconnect/",
    },
    {
      src: "/images/gmail.svg",
      alt: "gmail",
      href: "mailto:contact@aicapitalconnect.com",
    },
  ];

  return (
    <footer data-component-id="src/components/common/Footer.tsx:36:4" data-component-path="src/components/common/Footer.tsx" data-component-line="36" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%2C%22className%22%3A%22w-full%20bg-black%20py-8%22%7D" className="w-full bg-black py-8">
      <div data-component-id="src/components/common/Footer.tsx:37:6" data-component-path="src/components/common/Footer.tsx" data-component-line="37" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-24%20flex%20flex-col%20sm%3Aflex-row%20justify-between%20items-start%20sm%3Aitems-center%22%7D" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-24 flex flex-col sm:flex-row justify-between items-start sm:items-center">
        {/* Logo */}
        <div data-component-id="src/components/common/Footer.tsx:39:8" data-component-path="src/components/common/Footer.tsx" data-component-line="39" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%20sm%3Amb-0%22%7D" className="mb-6 sm:mb-0">
          <Link data-component-id="src/components/common/Footer.tsx:40:10" data-component-path="src/components/common/Footer.tsx" data-component-line="40" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%7D" href='/'>
          <Image data-component-id="src/components/common/Footer.tsx:41:10" data-component-path="src/components/common/Footer.tsx" data-component-line="41" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Ffooter-logo.svg%22%2C%22alt%22%3A%22footer-logo%22%2C%22className%22%3A%22w-%5B120px%5D%20sm%3Aw-%5B140px%5D%20lg%3Aw-%5B162px%5D%22%7D"
            src="/images/footer-logo.svg"
            alt="footer-logo"
            width={162}
            height={40}
            className="w-[120px] sm:w-[140px] lg:w-[162px]"
          />
          </Link>
        </div>

        {/* Social Icons Section */}
        <div data-component-id="src/components/common/Footer.tsx:52:8" data-component-path="src/components/common/Footer.tsx" data-component-line="52" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-start%20sm%3Aitems-end%20gap-2%22%7D" className="flex flex-col items-start sm:items-end gap-2">
          <span data-component-id="src/components/common/Footer.tsx:53:10" data-component-path="src/components/common/Footer.tsx" data-component-line="53" data-component-file="Footer.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-white%20text-sm%20font-medium%20tracking-wide%20w-full%22%2C%22textContent%22%3A%22FOLLOW%20US%22%7D" className="text-white text-sm font-medium tracking-wide w-full">FOLLOW US</span>
          <div data-component-id="src/components/common/Footer.tsx:54:10" data-component-path="src/components/common/Footer.tsx" data-component-line="54" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-3%20mt-1%22%7D" className="flex gap-3 mt-1">
            {socialLinks.map((social, index) => (
              <a data-component-id="src/components/common/Footer.tsx:56:14" data-component-path="src/components/common/Footer.tsx" data-component-line="56" data-component-file="Footer.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20rounded-full%20border%20border-white%20bg-transparent%20hover%3Abg-%5B%23171717%5D%20transition%20duration-200%22%7D"
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-white bg-transparent hover:bg-[#171717] transition duration-200"
                aria-label={social.alt}
              >
                <Image data-component-id="src/components/common/Footer.tsx:64:16" data-component-path="src/components/common/Footer.tsx" data-component-line="64" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B20px%5D%20h-%5B20px%5D%22%7D"
                  src={social.src}
                  alt={social.alt}
                  width={20}
                  height={20}
                  unoptimized
                  className="w-[20px] h-[20px]"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
